export const toItem = <T>(arr: T | T[]): T => {
  return Array.isArray(arr) ? arr[0] : arr;
};

export const toUnique = function <TItem>(
  array: TItem[],
  criteria: (a: TItem, b: TItem) => boolean = (a, b) => a === b
): TItem[] {
  return array.reduce<TItem[]>((acc, item1) => {
    const findTheSameItem = (item2: TItem) => {
      return criteria(item1, item2);
    };

    if (acc.find(findTheSameItem)) {
      return acc;
    }

    acc.push(item1);
    return acc;
  }, []);
};

export const didSelectionShrink = <TId extends string | number>(
  next: readonly { id: TId }[] | readonly TId[],
  prev: readonly { id: TId }[] | readonly TId[]
): boolean => {
  if (next.length === 0) return false;
  const getId = (item: { id: TId } | TId): TId =>
    typeof item === "object" && item !== null ? item.id : item;
  const nextIds = new Set(next.map(getId));
  return prev.some((item) => !nextIds.has(getId(item)));
};

export const interleave = <TItem, TSeparator>(
  array: TItem[],
  separator: TSeparator | ((index: number) => TSeparator)
): (TItem | TSeparator)[] => {
  return array.reduce(
    (acc, item, index) => {
      if (index > 0) {
        // @ts-expect-error Idk how to fix it
        acc.push(typeof separator === "function" ? separator(index) : separator);
      }

      acc.push(item);
      return acc;
    },
    [] as (TItem | TSeparator)[]
  );
};
